import { randomUUID } from './interface/Common'
import Model from './interface/Model'
// @ts-ignore
import {
  Segment,
  SegmentCondtionAction,
  SegmentCondtionType,
  SegmentTargetCondtion,
} from './interface/SegmentTargeting'

export default class CustomTargetingModule extends Model {
  public api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'audience_segment' as string | null,
      plural: 'audience_segments' as string | null,
    },
  }

  public static types_option = [
    {
      name: 'Key value',
      value: 'key_value',
    },
    {
      name: 'Segment',
      value: 'segment',
    },
  ]

  public static actions_option = [
    {
      name: 'Any Of',
      value: 'any_of',
    },
    {
      name: 'None Of',
      value: 'none_of',
    },
  ]

  public static createSegment() {
    return {
      id: randomUUID(),
      conditions: [this.newCondition()],
    }
  }

  public static newCondition() {
    return {
      type: SegmentCondtionType.KEY_VALUE,
      action: SegmentCondtionAction.ANY_OF,
      ids: [],
      id: randomUUID(),
    }
  }

  public static mapToSegment(value: Segment[]) {
    return value.map(segment => ({
      ...segment,
      id: segment.id || randomUUID(),
      conditions: segment.conditions.map(condition => {
        let id: any = {
          id: randomUUID(),
        }
        if (condition.id) {
          id = {}
        }
        return {
          ...condition,
          ...id,
        }
      }),
    }))
  }

  public static groupByType(value: Segment[]) {
    const result: any = {
      any_of: [],
      none_of: [],
    }
    value.forEach(segment => {
      segment.conditions.forEach(condition => {
        if (condition.action === SegmentCondtionAction.ANY_OF) {
          result.any_of = result.any_of.concat(condition.ids)
        } else if (condition.action === SegmentCondtionAction.NONE_OF) {
          result.none_of = result.none_of.concat(condition.ids)
        }
      })
    })

    return result
  }

  public static groupByExplicitType(value: Segment[]) {
    const result: any = {}
    value.forEach(segment => {
      segment.conditions.forEach(condition => {
        if (!result[condition.type]) {
          result[condition.type] = {
            any_of: [],
            none_of: [],
          }
        }

        if (condition.action === SegmentCondtionAction.ANY_OF) {
          result[condition.type].any_of = result[condition.type].any_of.concat(condition.ids)
        } else if (condition.action === SegmentCondtionAction.NONE_OF) {
          result[condition.type].none_of = result[condition.type].none_of.concat(condition.ids)
        }
      })
    })

    return result
  }
}
